module.exports = __webpack_public_path__ + "static/media/config.e06a1998.png";